<template>
  <v-col class="my-n2">
    <template v-if="item.type === 'string'">
      <v-autocomplete
        v-if="'enum' in item"
        :label="item.description"
        :items="item.enum"
        v-model="val"
        :rules="valueRules"
      >
      </v-autocomplete>
      <v-text-field
        v-else
        :label="item.description"
        v-model="val"
        :rules="stringRules"
        :counter="item.length"
      >
      </v-text-field>
    </template>
    <template v-if="item.type === 'integer'">
      <v-text-field
        :label="item.description"
        type="number"
        v-model="val"
        :rules="integerRules"
        :min="item.minimum"
        :max="item.maximum"
      >
      </v-text-field>
    </template>
    <template v-if="item.type === 'number'">
      <v-text-field
        :label="item.description"
        type="number"
        v-model="val"
        :rules="doubleRules"
        :min="item.minimum"
        :max="item.maximum"
      >
      </v-text-field>
    </template>
    <template v-if="item.type === 'object'">
      <v-spacer style="height: 1.5rem"></v-spacer>
      <v-row align="baseline" justify="start">
        <v-col v-for="(p, j) in item.properties" :key="j">
          <template v-if="val !== undefined">
            <BaseDynamicComponent
              v-model="val[j]"
              :item="p"
            ></BaseDynamicComponent>
          </template>
        </v-col>
      </v-row>
    </template>
    <template v-if="item.type === 'array'">
      <v-spacer style="height: 2rem"></v-spacer>
      <span class="pt-4">{{ item.description }}</span>
      <template v-if="val !== undefined">
        <v-spacer style="height: 1.0rem"></v-spacer>
        <v-row
          v-for="index in array.length"
          :key="index"
          align="baseline"
          justify="start"
        >
          <v-col v-for="(p, j) in item.properties" :key="j">
            <BaseDynamicComponent
              v-model="val[index - 1][j]"
              :item="p"
            ></BaseDynamicComponent>
          </v-col>

          <v-col cols="1" align-self="center">
            <v-row justify="center">
              <v-btn icon @click="removeElement(index - 1)">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <v-row class="pb-8">
        <v-spacer></v-spacer>
        <v-col cols="1" align-self="center">
          <v-row justify="center">
            <v-btn icon @click="pushElement">
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn></v-row
          ></v-col
        >
      </v-row>
    </template>
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      val: undefined
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    value: {
      required: true,
      default: function() {
        switch (this.item.type) {
          case "string":
          case "integer":
          case "number":
            return this.item.default;
          case "object":
            return {};
          case "array":
            var that = this;
            var keys = Object.keys(this.item.properties);
            var obj = {};
            keys.forEach(k => {
              if (that.item.properties[k].default !== undefined) {
                obj[k] = that.item.properties[k].default;
              } else {
                obj[k] = {};
              }
            });

            return [obj];
          default:
            return {};
        }
      }
    }
  },
  mounted() {
    this.val = this.value;
  },
  computed: {
    array() {
      return this.val;
    },
    valueRules() {
      return [v => !!v || "Value is required"];
    },
    integerRules() {
      return [
        v => !!v || !isNaN(v) || "Value is required",
        v =>
          ((!!v || !isNaN(v)) && /^[0-9]+$/.test(v)) || "Value must be integer",
        v =>
          ((!!v || !isNaN(v)) &&
            (v >= this.item.minimum || this.item.minimum === undefined)) ||
          "Value must be greater or equal than " + this.item.minimum,
        v =>
          ((!!v || !isNaN(v)) &&
            (v <= this.item.maximum || this.item.maximum === undefined)) ||
          "Value must be less or equal than " + this.item.maximum
      ];
    },

    doubleRules() {
      return [
        v => !!v || !isNaN(v) || "Value is required",
        v =>
          ((!!v || !isNaN(v)) &&
            (v >= this.item.minimum || this.item.minimum === undefined)) ||
          "Value must be greater or equal than " + this.item.minimum,
        v =>
          ((!!v || !isNaN(v)) &&
            (v <= this.item.maximum || this.item.maximum === undefined)) ||
          "Value must be less or equal than " + this.item.maximum
      ];
    },
    stringRules() {
      return [
        v => !!v || "Value is required",
        v => (!!v && v === v.toUpperCase()) || "String must be capitalized",
        v =>
          (!!v &&
            (v.length === this.item.length || this.item.length === undefined)) ||
          "String length must be equal " + this.item.length + " letters",
        v =>
          (!!v &&
            (this.item.format === undefined ||
              (this.item.format === "hexadecimal" &&
                /^[0-9a-fA-F]+$/.test(v)))) ||
          "Value length must be valid hexadecimal string"
      ];
    }
  },

  methods: {
    removeElement(index) {
      if (index > -1) {
        this.val.splice(index, 1);
      }
      this.$emit("input", this.val);
    },
    pushElement() {
      var that = this;
      var keys = Object.keys(this.item.properties);
      var obj = {};
      keys.forEach(k => {
        if (that.item.properties[k].default !== undefined) {
          obj[k] = that.item.properties[k].default;
        } else {
          obj[k] = {};
        }
      });
      this.val.push(obj);
    }
  },
  watch: {
    val: function() {
      if (this.item.type === "integer") {
        this.val = parseInt(this.val);
      }
      this.$emit("input", this.val);
    },
    value: function() {
      if (this.item.type === "integer") {
        this.val = parseInt(this.value);
      } else {
        this.val = this.value;
      }
      this.$emit("input", this.value);
    }
  }
};
</script>

